import { execute } from "../../helpers/apiInstance";


export const uploadDocsApi = (dataObj) => {
    const formData = new FormData();
    for ( var key in dataObj ) {
        formData.append(key, dataObj[key]);
    }
    return execute('POST', `/ui/apis/upload-attachment/`,formData ,'json','multipart/form-data');
}